import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/images/Logo.png';
import { FaInstagram, FaFacebook, FaWhatsapp, FaYoutube, FaTiktok, FaThreads, FaLinkedinIn, FaX } from 'react-icons/fa6';

const PRIMARY_NAV_ITEMS = [
  { type: 'link', label: 'Home', to: '/' },
  { type: 'section', label: 'About', sectionId: 'about' },
  { type: 'section', label: 'Objective', sectionId: 'objective' },
  { type: 'section', label: 'Vision & Mission', sectionId: 'vision-mission' },
  { type: 'section', label: 'Core Values', sectionId: 'core-values' },
  { type: 'section', label: 'Contact', sectionId: 'contact' },
];

const ACTION_NAV_ITEMS = [
  { label: 'Register - Professional', to: '/professional-register' },
  { label: 'Register - Hospital', to: '/hospital-register' },
  { label: 'Register - Patient', to: '/patient-register' },
  { label: 'Login', to: '/login' },
];

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const closeMobileMenu = () => {
    const collapse = document.getElementById('navbarNav');
    const toggler = document.querySelector('.main-header .navbar-toggler');
    if (collapse?.classList.contains('show')) {
      collapse.classList.remove('show');
      toggler?.setAttribute('aria-expanded', 'false');
    }
  };

  const handleSectionClick = (sectionId, e) => {
    e.preventDefault();
    closeMobileMenu();

    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }, 50);
    }
  };

  const renderPrimaryNavItem = (item, className = 'nav-link') => {
    if (item.type === 'link') {
      return (
        <Link className={className} to={item.to} onClick={closeMobileMenu}>
          {item.label}
        </Link>
      );
    }

    return (
      <a
        className={className}
        href={`#${item.sectionId}`}
        onClick={(e) => handleSectionClick(item.sectionId, e)}
      >
        {item.label}
      </a>
    );
  };

  return (
    <div className="header-sticky-wrapper">
      <div className="top-bar py-2">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6 col-12">
              <div className="d-flex flex-row flex-md-row gap-3 gap-md-4">
                <div className="info-item d-flex align-items-center gap-2">
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:info@247procare.com" className="text-decoration-none text-white">info@247procare.com</a>
                </div>
                <div className="info-item d-flex align-items-center gap-2">
                  <i className="fas fa-phone"></i>
                  <a href="tel:+919747888247" className="text-decoration-none text-white">(+91) 9747888247</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="d-flex justify-content-md-end justify-content-center gap-3 mt-2 mt-md-0">
                <a href="https://www.instagram.com/247_procare?igsh=MW5la2NrNHZseXFpYg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram" title="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://www.facebook.com/share/1CNTp3CMfV/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook" title="Facebook">
                  <FaFacebook />
                </a>
                <a href="https://x.com/247procare?s=11" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X" title="X">
                  <FaX />
                </a>
                <a href="https://wa.me/message/6TVTKQQI277UJ1" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="WhatsApp" title="WhatsApp">
                  <FaWhatsapp />
                </a>
                <a href="https://youtube.com/@247procare?si=Vn3Iill4Z-pTgYVT" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube" title="YouTube">
                  <FaYoutube />
                </a>
                <a href="https://www.tiktok.com/@247_procare?_r=1&_t=ZN-93EDmosinTC" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok" title="TikTok">
                  <FaTiktok />
                </a>
                <a href="https://www.threads.com/@247_procare?igshid=NTc4MTIwNjQ2YQ==" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Threads" title="Threads">
                  <FaThreads />
                </a>
                <a href="https://www.linkedin.com/in/twenty-four-seven-pro-care-846188390?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn" title="LinkedIn">
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className="main-header">
        <nav className="navbar navbar-expand-lg py-1 navbar-light">
          <div className="container-fluid">
            <Link className="navbar-brand me-5" to="/">
              <img src={logo} alt="24/7 ProCare Logo" className="logo-img" />
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <div className="mobile-nav-panel d-lg-none">
                <ul className="navbar-nav mobile-nav-actions">
                  {ACTION_NAV_ITEMS.map((item) => (
                    <li className="nav-item" key={item.to}>
                      <Link className="nav-link" to={item.to} onClick={closeMobileMenu}>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
                <hr className="mobile-nav-divider" />
                <ul className="navbar-nav mobile-nav-primary">
                  {PRIMARY_NAV_ITEMS.map((item) => (
                    <li className="nav-item" key={item.label}>
                      {renderPrimaryNavItem(item)}
                    </li>
                  ))}
                </ul>
              </div>

              <ul className="navbar-nav me-auto d-none d-lg-flex">
                {PRIMARY_NAV_ITEMS.map((item) => (
                  <li className="nav-item" key={item.label}>
                    {renderPrimaryNavItem(item)}
                  </li>
                ))}
              </ul>

              <div className="d-none d-lg-flex align-items-center gap-2 header-action-buttons">
                {isHomePage && (
                  <Link to="/patient-register" className="btn menu-btn register-patient-header-btn">
                    <i className="fas fa-user-plus me-2" aria-hidden="true" />
                    Register Patient
                  </Link>
                )}
                <div className="dropdown">
                  <button
                    className="btn menu-btn dropdown-toggle"
                    type="button"
                    id="menuDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fas fa-bars me-2"></i>
                    Menu
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="menuDropdown">
                    {ACTION_NAV_ITEMS.map((item) => (
                      <li key={item.to}>
                        <Link className="dropdown-item" to={item.to}>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default Header;
